import { TableauHttpClient } from 'common/services/httpClient';

type TableauReport = {
  id: string;
  name: string;
};

type TableauReportsResponse = {
  contentType: string;
  serializerSettings: string;
  statusCode: number;
  value: string;
  data: TableauReport[];
  errors: {
    apiErrorType: number;
    apiErrorCode: string;
    apiErrorMessage: string;
    isSafeForClientViewing: boolean;
  }[];
};

export const getTableauReports = async (
  projectId: string,
  engagementId: string
): Promise<TableauReportsResponse['data'] | boolean> => {
  try {
    const response = (await TableauHttpClient.get(
      `projects/${projectId}/tableauReports?engagementId=${engagementId}`
    )) as TableauReportsResponse;
    return response.data;
  } catch (e) {
    return false;
  }
};

export type TableauData = {
  embedUrl: string;
};

type TableauReportDetailResponse = {
  contentType: string;
  serializerSettings: string;
  statusCode: number;
  value: string;
  data: TableauData;
  errors: {
    apiErrorType: number;
    apiErrorCode: string;
    apiErrorMessage: string;
    isSafeForClientViewing: boolean;
  }[];
};

export const getTableauReportDetail = async (
  projectId: string,
  engagementId: string,
  reportId: string
): Promise<TableauData | boolean> => {
  try {
    const response = (await TableauHttpClient.get(
      `projects/${projectId}/tableauReports/${reportId}?engagementId=${engagementId}`
    )) as TableauReportDetailResponse;
    return response.data;
  } catch (e) {
    return false;
  }
};
export const getTableauAutoSyncUrl = async (
  projectId: string,
  engagementId: string,
  reportId: string
): Promise<TableauData> => {
  const response = (await TableauHttpClient.get(
    `projects/${projectId}/tableauReports/${reportId}/autosync?engagementId=${engagementId}`
  )) as TableauReportDetailResponse;
  return response.data;
};

export const getReportDataByReportIdAsPng = async (
  projectId: string,
  reportId: string
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const response = await TableauHttpClient.get(
    `projects/${projectId}/tableauReports/${reportId}/AsPng`
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
  return response.data;
};
